import { useUserPreferences } from '@/hooks/use-user-preferences';
import { refreshLocale } from '@/lib/i18n';
import { useEffect } from 'react';
import { GENERAL_SETTINGS_CHANGED_EVENT, isSameGeneralConfig, loadGeneralSettings, mergeRemoteGeneralSettings, saveGeneralSettings, } from './generalSettingsStorage';
/**
 * Render-nothing bridge that copies the account's regional preferences
 * (timezone, clock, locale, sidebar clinic name) into this browser's general
 * settings storage once they load, so a user who picked English (UK) on one
 * machine sees day-first dates on every other machine from the first paint,
 * not only after opening Settings > General there. Formatting reads that
 * storage synchronously, so when a field actually changes the locale is
 * re-applied to re-render what is already on screen. Place inside the
 * auth/query provider tree.
 */
export function GeneralSettingsBridge() {
    const { preferences, isLoaded } = useUserPreferences();
    useEffect(() => {
        if (!isLoaded)
            return;
        const local = loadGeneralSettings();
        const merged = mergeRemoteGeneralSettings(local, preferences);
        if (isSameGeneralConfig(local, merged))
            return;
        saveGeneralSettings(merged);
        window.dispatchEvent(new Event(GENERAL_SETTINGS_CHANGED_EVENT));
        void refreshLocale(merged.locale);
    }, [isLoaded, preferences]);
    return null;
}
